// extracted by mini-css-extract-plugin
export default {"containerCard":"CharacterCard_containerCard__e6o-i","detailsOverlay":"CharacterCard_detailsOverlay__uvkoE","briefInfo":"CharacterCard_briefInfo__NpdZY"};